<template>
    <div class="p-8 bg-gray-50 rounded-lg shadow" style="text-align: center;">
        <section>
            <h2>제 1 장 총칙</h2>
            <h3>제 1 조 (목적)</h3>
            <p>1. 이 약관은 팀페이버드(이하 “회사”라 합니다)가 운영하는 모바일 앱(혹은 모바일 웹)을 통해 인터넷 관련 서비스를 제공함에 있어, 회사가 제공하는 서비스와 관련하여 이를 이용하는
                가입자(이하 ‘”회원” 또는 “개인회원”)의 이용조건 및 제반 절차, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

            <h3>제 2 조 (용어의 정의)</h3>
            <p>① 이 약관에서 사용하는 용어의 정의는 아래와 같습니다.</p>
            <ol>
                <li>웹사이트/모바일 앱: 회사가 서비스를 회원에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 설정한 가상의 영업장 또는 회사가 앱거래 플랫폼에 등록하여 운영하는 모바일 앱을
                    말하며, 통합된 하나의 아이디 및 비밀번호를 이용하여 서비스를 제공받을 수 있는 아래의 서비스로 정의합니다.</li>
                <li>NumberFavored: NumberFavored 웹사이트/모바일 앱</li>
                <li>회원 : 서비스를 이용하기 위하여 약관에 동의하고 "회사"의 이용동의를 받은 회원ID를 부여 받은 개인 및 기업과 단체를 말합니다.</li>
                <li>회원 서비스 : “개인회원”이 “NumberFavored” 사이트/앱에 개인정보를 제공하여 회원등록을 하고 부여 받은 회원 ID 및 비밀번호로 위의 세 서비스에 자유롭게 접속할 수
                    있는 서비스를 말합니다.</li>
                <li>이용자ID(회원ID) : 회원의 식별과 회원의 서비스 이용을 위하여 회원의 계정을 말합니다.</li>
                <li>비밀번호 : "회사"의 서비스를 이용하려는 사람이 이용자ID로 로그인 하려는 자와 동일인임을 확인하고 회원의 권익을 보호하기 위하여 회원이 선정한 로그인 권한을 가진 문자와 숫자의
                    조합을 말합니다.</li>
                <li>운영자 : 회사에서 제공하는 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 임명한 사람을 말합니다.</li>
                <li>휴면회원 : 서비스 요금이 무료인 회원의 개인정보보호를 위해(회원의 ID, 비밀번호 도용 방지를 위해) 연속하여 1년 동안 어떠한 단말에서도 서비스에 접속(로그인)을 하지 않아
                    휴면 상태로 전환된 회원을 말하며, 별도의 본인인증절차를 통하여 휴면 상태 해제 후 이용이 가능합니다.</li>
            </ol>

            <h3>제 3 조 (약관의 명시, 효력, 개정)</h3>
            <ol>
                <li>이 약관은 회사가 서비스하는 홈페이지에 게시하여 공시함으로써 효력이 발생합니다.</li>
                <li>회사는 합리적인 사유 발생시 약관의 규제에 관한 법률, 전자거래기본법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률 등
                    관련 법령에 위배되지 않는 범위 내에서 이 약관을 변경할 수 있으며, 회사가 약관을 변경한 경우에는 적용일자 및 변경사유를 명시하여 지체 없이 이를 공시합니다. 단, 요금 등
                    이용고객의 권리 또는 의무에 관한 중요한 규정의 변경은 최소한 7일 전 웹사이트 초기화면 또는 공지사항 또는 전자메일 등을 통해 고지합니다.(단, 전자메일 혹은 SMS를 통해 개별
                    공지하는 경우 이용자의 연락처 미기재, 변경 등으로 인하여 개별 통지가 어려운 경우에 한하여 본 약관에 의한 공지를 함으로써 개별 통지한 것으로 간주합니다.)</li>
                <li>변경된 이용약관의 효력은 약관 변경 전에 가입한 회원 전체에게 소급해서 적용됩니다.</li>
                <li>이 약관에 동의하는 것은 정기적으로 회사가 운영하는 모바일앱/웹사이트를 방문하여 약관의 변경사항을 확인하는 것에 동의함을 의미합니다. 변경된 약관에 대한 정보를 알지 못하여
                    발생하는 회원 또는 이용자의 피해에 대하여 회사는 책임을 부담하지 않습니다.</li>
                <li>이용자는 변경된 약관에 대해 거부할 권리가 있으며, 변경된 약관이 공지된 지 15일 이내에 거부의사를 표명할 수 있습니다. 이용자가 거부하는 경우 본 서비스 제공자인 회사는
                    15일의 기간을 정하여 이용자에게 사전 통지 후 당해 이용자와의 계약을 해지할 수 있습니다. 만약, 이용자가 거부의사를 표시하지 않고 서비스를 계속 이용하는 경우에는 변경된
                    이용약관에 동의하는 것으로 간주합니다.</li>
            </ol>

            <h3>제 4 조 (약관 외 준칙)</h3>
            <ol>
                <li>이 약관에 명시되지 않은 사항은 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령의 규정과 일반 상관례에 의합니다.</li>
                <li>회사는 필요한 경우 특정 서비스에 관하여 적용될 사항(이하 “개별약관”이라 함)을 정하여 이를 NumberFavored 사이트를 통해 공지할 수 있습니다.</li>
                <li>회사는 필요한 경우 서비스 이용과 관련된 세부적인 내용(이하 “이용정책”이라 함)을 정하여 이를 NumberFavored 사이트를 통해 공지할 수 있습니다.</li>
                <li>개별약관이나 이용정책의 변경이 있을 경우 회사는 변경 내용의 효력발생일 7일 이전에 해당 변경사항을 공지합니다.</li>
                <li>회원은 항상 개별약관이나 이용정책의 내용에 변경이 있는지 여부를 주시하여야 하며, 변경사항의 공지가 있을 시에는 이를 확인하여야 합니다.</li>
            </ol>

            <h2>제 2 장 서비스 이용계약</h2>

            <h3>제 5 조 (이용계약의 성립)</h3>
            <ol>
                <li>회사의 서비스 이용계약(이하 “이용계약”이라 함)은 서비스를 이용하고자 하는 자의 본 약관과 개인정보취급방침의 내용에 대한 동의 및 이용신청(회원가입신청)에 대하여 회사가
                    승낙함으로써 성립합니다.</li>
                <li>서비스를 이용하고자 하는 자가 이용신청 당시 앱/웹상의 “동의” 버튼에 체크 후 회원가입 과정을 완료 시 본 약관 및 개인정보취급방침에 대하여 동의한 것으로 간주합니다.</li>
                <li>제 1항의 승낙은 이용신청자의 본 약관에 대한 동의를 확인하고 전자메일 또는 서면으로 통지함으로써 이루어지고 이러한 승낙의 통지가 이용신청자에게 도달하면 이용계약이 성립됩니다.
                </li>
            </ol>

            <h3>제 6 조 (개인정보 변경, 보호)</h3>
            <ol>
                <li>회원은 이용신청 시 제공한 계정 등에 변경사항이 생겼을 경우 즉시 변경사항을 최신의 정보로 수정하여야 합니다. .</li>
                <li>수정하지 않은 정보로 인하여 발생하는 손해는 회원이 부담하며, 회사는 이에 대하여 아무런 책임을 지지 않습니다.</li>
                <li>회사는 회원의 정보를 서비스를 제공하기 위한 목적 이외의 용도로 사용하거나 이용자의 동의 없이 제 3자에게 제공하지 않습니다. 단, 다음의 경우는 예외로 합니다.</li>
                <li>법령이 회원의 개인정보의 이용과 제 3자에 대한 정보제공을 허용하고 있는 경우</li>
                <li>구매가 성사된 때에 그 이행을 위하여 필요한 경우와 구매가 종료된 이후에도 반품, 교환, 환불, 취소 등을 위하여 필요한 경우</li>
                <li>회사는 회원의 개인정보를 보호하기 위한 정책을 수립하고 개인정보보호 책임자를 지정하여 이를 게시합니다.</li>
            </ol>

            <h3>제 7 조 (서비스 이용신청)</h3>
            <ol>
                <li>회원으로 가입하여 본 서비스를 이용하고자 하는 개인이용고객은 가입한 계정을 통해 서비스를 이용할 수 있습니다. .</li>
                <li>실명으로 등록하지 않은 사용자는 일체의 권리를 주장할 수 없습니다.</li>
                <li>타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에 따라 처벌을 받을 수 있습니다.</li>
            </ol>

            <h3>제 8 조 (이용신청의 승낙과 제한)</h3>
            <ol>
                <li>회사는 전조의 규정에 의한 이용신청 고객에 대하여 업무수행상 또는 기술상 지장이 없는 경우에는 원칙적으로 접수순서에 따라 서비스 이용을 승낙합니다.</li>
                <li> 2. 회사는 다음 각 호에 해당하는 사항을 인지하였을 경우 서비스 이용신청을 승낙하지 않을 수 있습니다.</li>
                - 실명이 아니거나 타인의 명의를 이용하여 신청한 경우
                - 회원가입 시 기재 사항을 허위로 기재하였을 경우
                - 이용신청 고객이 회사에 납부하여야 할 요금 등을 납부하지 않을 경우
                - 기타 이용신청자의 귀책 사유로 이용 승낙이 곤란한 경우
                - 회사가 설비에 여유가 없는 경우 - 회사의 기술상 지장이 있는 경우
                - 제공한 서비스가 회원의 요구사항을 충족시킬 수 없는 경우
                - 기타 회사의 사정(회사의 귀책사유가 있는 경우도 포함)으로 이용승낙이 곤란한 경우
                <li>3. 회사는 제 2항의 규정에 의하여 이용신청을 승낙하지 않을 경우 이를 이용신청자에게 알려야 합니다.
                    단, 고의 또는 과실 등 이용 신청자의 책임 사유로 통지할 수 없는 경우에는 알리지 않을 수 있습니다.</li>
            </ol>


            <h2>제 3 장 계약자의 의무</h2>

            <h3>제 9 조 (회사의 의무)</h3>
            <ol>
                <li>회사는 본 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다해야 합니다.</li>
                <li>회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 즉시 처리하여야 하며, 즉시 처리가 곤란한 경우에는 그 사유와 처리일정을 서비스 화면 또는 기타 방법을 통해 동
                    회원에게 통지하여야 합니다.</li>
                <li>회사는 회원이 요청하는 건의•제안사항을 적극 수렴하여 보다 나은 서비스가 될 수 있도록 최선을 다해야 합니다.</li>
                <li>회사는 유료결제와 관련한 결제사항 정보를 상법 등 관련법령의 규정에 의하여 5년 이상 보존해야 합니다.</li>
                <li>천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여 서비스가 중단될 경우 이에 대한 손해에 대해서는 회사가 책임을 지지 않습니다. 다만, 자료의 복구나 정상적인
                    서비스 지원이 되도록 최선을 다할 의무를 지닙니다.</li>
                <li>회사는 회원의 신상정보를 제 3자에게 누설, 배포하지 않습니다. 단, 다음과 같은 경우는 그러하지 않습니다.
                    <ul>
                        <li>전기통신기본법 등 법률의 규정에 의해 국가 기관의 요구가 있는 경우</li>
                        <li>범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우</li>
                        <li>기타 관계법령에서 정한 절차에 따른 요청이 있는 경우</li>
                    </ul>
                </li>
                <li>회원의 자료를 본 서비스 이외의 목적으로 제 3자에게 제공하거나 열람시킬 경우 반드시 사전에 회원의 동의를 얻어야 합니다.</li>
                <li>회사는 제 3자로부터 명예훼손, 지적재산권, 개인적인 프라이버시를 침해하는 이유로 피해 회원으로부터 게시중단 요청을 받을 경우 임시로 게시 중단을 할 수 있습니다.</li>
            </ol>

            <h3>제 10 조 (회원의 의무)</h3>
            <ol>
                <li>회원은 관계법령과 본 약관의 규정 및 기타 회사가 통지하는 사항을 준수하여야 하며, 기타 회사의 업무에 방해가 되는 행위를 해서는 안됩니다.</li>
                <li>회원의 아이디, 비밀번호 등의 회원정보 관리 소홀로 인해 발생하는 모든 결과에 대한 책임은 회원에게 있으며, 자신의 ID를 타인이 사용하거나 부정하게 사용된 경우 회원은 반드시
                    회사에 그 사실을 통보해야 합니다.</li>
                <li>회원이 결제수단으로 신용카드를 사용할 경우 비밀번호 등 정보 유실 방지는 회원 스스로 관리해야 합니다. 단, 사이트의 결함에 따른 정보유실의 발생에 대한 책임은 회원의 의무에
                    해당하지 않습니다.</li>
                <li>회원은 회사에서 제공하는 서비스를 바탕으로 영업활동을 할 수 없으며, 이로 인해 발생하는 모든 문제에 대해서 회원은 회사에 손해배상의 의무를 져야 합니다.</li>
                <li>회원은 서비스를 이용하여 얻은 정보를 회사의 사전동의 없이 복사, 복제, 번역, 출판, 방송, 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.</li>
                <li>회원이 '회사' 홈페이지에 저작권이 있는 데이터를 등록하여 발생하는 법적인 책임은 회원에게 있으며 서비스를 제공하는 회사는 책임을 지지 않습니다.</li>
                <li>회원은 다음과 같은 행위를 해서는 안됩니다.
                    <ul>
                        <li>다른 회원의 아이디를 부정 사용하는 행위</li>
                        <li>범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위</li>
                        <li>타인의 명예를 훼손하거나 모욕하는 행위</li>
                        <li>타인의 지적재산권 등의 권리를 침해하는 행위</li>
                        <li>해킹행위 또는 바이러스 유표 행위</li>
                        <li>타인의 의사에 반하여 광고성 정보 등 일정한 내용을 계속적으로 전송하는 행위</li>
                        <li>서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있다고 판단되는 행위</li>
                        <li>사이트의 정보 및 서비스를 이용한 영리 행위</li>
                        <li>그 밖에 선량한 풍속, 기타 사회질서를 해하거나 관계법령에 위반하는 행위</li>
                    </ul>
                </li>
                <li>본 약관에서 다루는 모바일 앱/웹 사이트 내의 컨텐츠는 개인이 학습용으로만 활용 가능합니다. 업체나 개인이 타인에게 교육이나 정보를 제공하기 위해서 사용할 수 없으며, 이 경우
                    별도의 계약을 통해 별도의 컨설팅 솔루션을 이용해야 합니다.</li>
            </ol>

            <h2>제 4 장 서비스 이용</h2>

            <h3>제 11 조 (저작권 정책)</h3>
            <ol>
                <li>회사는 서비스를 이용함에 있어 저작권자의 저작권 보호를 위한 정책을 수립하여 운영하며, 회원은 회사의 저작권 정책을 준수하여야 합니다.</li>
                <li>회원은 회사에서 제공하는 정보를 가공, 판매하는 상업적 행위, 무단복제 및 배포하는 행위는 할 수 없습니다.</li>
                <li>회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다.</li>
                <li>이용자는 NumberFavored를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송, 기타 방법에 의하여 이용하거나 제 3자에게 이용하게 하는
                    경우 그에 대한 책임은 이용자 본인에게 있습니다.</li>
                <li>회사는 다음 각 항의 경우 사전통보 없이 게시물을 삭제하거나 게시자에 대하여 특정 서비스의 이용제한 또는 정지, 이용계약의 해지 등의 조치를 할 수 있습니다.
                    <ul>
                        <li>대한민국의 법령을 위반하는 내용을 포함하는 경우</li>
                        <li>타인의 권리나 명예, 신용, 기타 정당한 이익을 침해하는 경우</li>
                        <li>정보통신기기의 오작동을 일으킬 수 있는 악성코드나 데이터를 포함하는 경우</li>
                        <li>사회 공공질서나 미풍약속에 위배되는 경우</li>
                        <li>회사가 제공하는 서비스의 원활한 진행을 방해하는 것으로 판단되는 경우</li>
                    </ul>
                </li>
            </ol>

            <h3>제 12 조 (정보제공 및 광고 게재)</h3>
            <ol>
                <li>회사는 회원이 서비스 이용 중 필요하다고 판단되는 정보에 대해서 전자우편, 서신우편 및 광고수단 등의 방법으로 회원에게 제공할 수 있으며, 회원은 원치 않을 경우 수신거부를 할 수
                    있습니다.</li>
                <li>회사는 제공하는 서비스와 관련되는 정보 또는 광고를 서비스 화면, 웹사이트 등에 게재할 수 있으며, 회원들에게 메일을 통해 알릴 수 있습니다.</li>
                <li>회사는 서비스상에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에 회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 모든 손실과 손해에 대한 책임을 지지 않습니다.
                </li>
                <li>본 서비스의 회원은 서비스 이용시 노출되는 광고게재에 대해 동의하는 것으로 간주합니다.</li>
            </ol>

            <h3>제 13 조 (서비스의 구분)</h3>
            <p>회사의 서비스는 회원으로 가입한 고객에게만 제공되며 서비스는 무료와 유료로 구분됩니다.</p>
            <ol>
                <li>무료 서비스 : 모바일 앱/웹 등에서 결제없이 이용할 수 있는 서비스로 1회 추첨권도 이에 포함됩니다.</li>
                <li>유료 서비스 : 모바일 앱/웹 등에서 결제를 통해 사용할 수 있는 서비스로 통상 무료 서비스를 제외한 나머지 모든 서비스를 말합니다.</li>
            </ol>

            <h3>제 14 조 (서비스 이용시간)</h3>
            <ol>
                <li>회사는 특별한 사유가 없는 한 연중무휴, 1일 24시간 서비스를 제공합니다. 다만, 로또 추첨일인 매주 토요일 8시부터 자정까지는 이용이 제한될 수 있습니다.</li>
                <li>회사는 서비스의 종류나 성질에 따라 제공하는 서비스 중 일부에 대해서는 별도로 이용시간을 정할 수 있으며, 이 경우 회사는 그 이용시간을 사전에 회원에게 공지 또는 통지하여야
                    합니다.</li>
                <li>회사는 자료의 가공과 갱신을 위한 시스템 작업시간, 장애해결을 위한 보수작업 시간, 정기 PM작업, 시스템 교체작업, 회선 장애 등이 발생한 경우 일시적으로 서비스를 중단할 수
                    있으며 계획된 작업의 경우 공지란에 서비스 중단시간과 작업내용을 알려야 합니다.</li>
            </ol>

            <h3>제 15 조 (서비스 제공의 중지)</h3>
            <ol>
                <li>회사는 다음 각 호에 해당되는 경우 서비스 제공을 중지할 수 있습니다.
                    <ul>
                        <li>서비스 제공용 설비의 보수 및 증설로 인해 사전에 회원들에게 통지한 경우</li>
                        <li>전기통신사업법에 규정된 기간통신 사업자가 전기통신 서비스를 중지했을 경우</li>
                        <li>기타 불가항력적 사유가 있는 경우</li>
                    </ul>
                </li>
                <li>회사는 국가비상사태, 천재지변, 이용자 폭주 등으로 인해 서비스 이용에 지장이 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.</li>
                <li>회원은 1년 동안 어떠한 단말에서도 서비스에 접속(로그인)을 하지 않는 경우 휴면 상태로 전환될 수 있습니다.(7일 전 통지)</li>
                <li>휴면 상태로 전환된 회원(이하 "휴면 회원")은 서비스 접속이 제한되며 지속적인 사용을 원할 경우 각 서비스의 모바일앱/웹에서 별도의 본인인증 절차를 통하여 휴면 상태 해제 후
                    이용할 수 있습니다.</li>
            </ol>

            <h2>제 5 장 계약해지 및 이용제한</h2>

            <h3>제 16 조 (계약해지 및 이용제한)</h3>
            <ol>
                <li>개인회원이 가입 해지를 하고자 할 때는 고객센터 또는 "회원탈퇴" 메뉴를 통하여 해지 신청을 해야 합니다. 탈퇴 신청시 회원은 NumberFavored에서 탈퇴해야 합니다. 단,
                    회원이 자발적으로 회원탈퇴를 한 경우 1개월간 재가입을 할 수 없습니다.</li>
                <li>회원 재가입, 임의해지 등을 반복적으로 행함으로써 회사가 제공하는 각종 할인 및 혜택 등의 경제상의 이익을 편법적으로 수취하거나 이 과정에서 명의도용 등의 행위 우려가 있으므로
                    이러한 불•편법 행위 차단 등의 목적으로 회원이 자발적인 의사로 회원탈퇴를 한 후 1개월이 지나지 아니한 경우에는 회원의 서비스 이용계약은 거부될 수 있습니다.</li>
                <li>회사는 회사에 불이익을 주거나 기타 적절치 못한 정보를 등록한 회원의 경우 경고 조치 또는 강제 탈퇴 처리할 수 있으며, 강제 탈퇴된 회원은 6개월 동안 재가입을 할 수 없습니다.
                </li>
                <li>회원이 다음 사항에 해당되는 경우 회사는 사전동의 없이 강제탈퇴 또는 서비스 중지 처리할 수 있습니다.
                    <ul>
                        <li>회사로부터 6개월 동안 경고 2회를 받은 경우</li>
                        <li>회원이 등록한 정보의 내용이 사실과 다르거나 조작되었을 때</li>
                        <li>회원이 등록한 정보의 내용이 사실과 다르거나 조작되었을 때</li>
                        <li>회사의 서비스를 고의적으로 방해한 경우</li>
                        <li>같은 아이디로 2명 이상이 사용한 경우</li>
                        <li>공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우</li>
                        <li>회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스를 이용한 경우</li>
                        <li>회사 또는 회원의 지적 저작권이 있는 정보를 무단으로 등록한 경우</li>
                        <li>타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</li>
                        <li>타인에게 모욕적, 협박적, 혐오적인 내용들이 담긴 글을 전송, 게시한 경우</li>
                        <li>회사의 서비스 정보를 이용하여 얻는 정보를 사전승낙 없이 복제 또는 유통시키거나 상업적으로 이용한 경우</li>
                        <li>기타 관계법규에 위배되는 내용이거나 사이트의 원활한 운영을 위하여 운영자가 필요하다고 판단한 경우</li>
                    </ul>
                </li>
                <li>회사와 회원의 계약이 해지될 경우 회원의 모든 데이터는 소멸되며, 그 동안 보유한 이용권 및 바우처 등도 모두 삭제되어 복구되지 않습니다.</li>
                <li>회원이 이용계약 종료(해지 포함) 후 재가입하는 경우에는 최종 이용시 사용한 아이디를 사용할 수 없으며, 새로운 아이디를 사용하는 것을 원칙으로 합니다.</li>
            </ol>

            <h2>제 6 장 서비스 이용요금 및 환불조건</h2>

            <h3>제 17 조 (이용요금)</h3>
            <ol>
                <li>회사는 유료서비스를 제공할 경우 모바일 앱/웹 사이트에 요금에 대하여 공지를 하여야 한다.</li>
                <li>회사는 유료서비스 이용금액이 변경되는 경우 변경된 금액 적용일 최소 7일전(금액의 변경이 소비자에게 불리한 경우에는 30일전)부터 웹사이트 초기화면 공지사항 또는 전자메일을 통해
                    고지합니다. 단, 변경 이전에 적용 또는 계약한 금액은 소급하여 적용하지 않습니다.</li>
            </ol>

            <h3>제 18 조 (이용요금 결제수단)</h3>
            <ol>
                <li>회원이 필요로 하는 콘텐츠를 이용하기 위해서는 회사에서 지정한 결제 수단으로 이용권을 구매한 후 이용할 수 있습니다.</li>
                <li>결제 수단은 앱 플랫폼내의 구글결제, 애플 결제 등으로 구분됩니다.</li>
            </ol>

            <h3>제 19 조 (이용요금 이의신청)</h3>
            <ol>
                <li>회원은 선납한 요금 등에 이의가 있을 경우 이의 신청을 할 수 있습니다.</li>
                <li>회사는 전항의 이의신청 접수 후 10일 이내 타당성 여부를 조사하고, 그 결과를 회원에게 통지하여야 합니다.</li>
            </ol>

            <h3>제 20 조 (환불 원칙)</h3>
            <ol>
                <li>회사는 요금 등의 과•오납이 있을 때에는 그 과•오납된 요금을 반환하여야 합니다.</li>
                <li>제 16조 4항에 따라 이용제한이 될 경우 요금은 반환하지 않습니다.</li>
                <li>결제/입금이 완료된 회원이 서비스 이용 전에 환불을 요청하는 경우에는 환불 또는 동일금액의 타 서비스로 대체 처리하며, 이미 서비스를 이용한 회원에게는 환불을 하지 않는 것을
                    원칙으로 합니다. 또한, 환불은 팀페이버드 환불정책에 의거하여 처리됩니다.</li>
                <li>회원의 단순변심에 의해 소요되는 환불 비용과 프리미엄 플랜 회원의 이벤트 환불 등 (결제수단에 따른 수수료 포함)에 소요되는 문자 발송 수수료 등은 회원이 부담합니다.</li>
            </ol>


            <h2>제 7 장 손해배상 및 면책</h2>

            <h3>제 21 조 (손해배상)</h3>
            <ol>
                <li>회사가 제공하는 모든 서비스와 관련하여 회사의 책임 있는 사유로 인해 이용자에게 손해가 발생한 경우 회사는 그 손해를 배상하여야 합니다. 단, 회사는 무료서비스의 장애 등으로 인한
                    손해에 대해서는 배상하지 않습니다.</li>
                <li>회원이 본 약관 규정에 위반한 행위로 회사 및 제 3자에게 손해를 입히거나 회원의 책임 있는 사유에 의해 회사 및 제 3자에게 손해를 입힌 경우 회원은 그 손해를 배상하여야
                    합니다.</li>
                <li>기타 손해배상의 방법, 절차 등은 관계법령에 따릅니다.</li>
            </ol>

            <h3>제 22 조 (면책)</h3>
            <ol>
                <li>회사는 회원이 회사의 서비스 제공으로부터 기대되는 이익을 얻지 못한데 대해서는 책임이 없습니다.</li>
                <li>회사는 동 회원이 제공한 정보로 인한 손해에 대해서는 책임이 없습니다.</li>
                <li>회사는 동 회원간의 서비스를 매개로 발생한 기타 분쟁에 대해서는 개입할 의무도 이로 인한 손해를 배상할 책임도 없습니다.</li>
                <li>회사는 회원의 귀책사유로 인하여 서비스 이용의 장애가 발생한 경우에는 책임이 없습니다.</li>
                <li>회사는 안정적인 서비스 제공을 위한 월 40시간 이내의 일정한 서비스 점검에 관하여 사전에 공지사항을 통하여 서비스 점검 일정 등을 고지한 경우, 해당 서비스 점검시간 동안 회원의
                    서비스 이용이 불가한 경우에 대해서는 보상책임이 없습니다.</li>
                <li>회사는 제15조 서비스 제공의 중지, 휴먼상태로 인한 서비스 이용 제한, 데이터 삭제 등에 따른 손해를 입은 경우 책임이 없습니다.</li>
            </ol>

            <h3>제 23 조 (분쟁의 해결)</h3>
            <ol>
                <li>회사와 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.</li>
                <li>회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리하며, 다만 신속한 처리가 어려운 경우에는 이용자에게 그 사유와 처리 일정을 통보합니다.</li>
                <li>1항의 노력에도 불구하고 회사와 회원 간에 발생한 전자거래 분쟁에 관한 소송은 제소 당시의 회원의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속 관할로
                    합니다. 단, 제소 당시 회원의 주소 또는 거소가 분명하지 아니하거나, 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.</li>
            </ol>

            <h3>제 24 조 (관할법원)</h3>
            <p>서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.</p>
        </section>
    </div>
</template>

<script setup>
</script>

<style scoped></style>
